var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"json-output output"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"json-source"},[_c('pre',[_vm._v(_vm._s(_vm.$store.getters.json))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }